var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 50,
    viewBox: "0 0 164 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-100 -386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 164,
    height: 50,
    rx: 6,
    transform: "translate(100 386)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_228_",
    transform: "translate(90.379 396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    d: "M29.152,76.271c-2.56,4.442-.932,11.183,1.9,15.27,1.413,2.043,2.843,3.878,4.8,3.878l.112,0a5.931,5.931,0,0,0,2.229-.594,6.1,6.1,0,0,1,2.64-.626,5.74,5.74,0,0,1,2.513.605,5.325,5.325,0,0,0,2.408.577c2.207-.041,3.562-2.02,4.758-3.766a16.7,16.7,0,0,0,2.084-4.27l.009-.027a.248.248,0,0,0-.132-.3L52.455,87a6.326,6.326,0,0,1-3.834-5.793A6.512,6.512,0,0,1,51.7,75.766l.024-.015a.248.248,0,0,0,.07-.349,7.161,7.161,0,0,0-5.633-3.059c-.16-.016-.325-.024-.491-.024a9.819,9.819,0,0,0-3.535.883,5.682,5.682,0,0,1-1.693.506,5.54,5.54,0,0,1-1.752-.512,8.488,8.488,0,0,0-3.087-.784h-.078A7.57,7.57,0,0,0,29.152,76.271Z",
    transform: "translate(0 -65.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_230_",
    d: "M155.453,0a6.913,6.913,0,0,0-4.564,2.341,6.477,6.477,0,0,0-1.64,4.8.248.248,0,0,0,.227.215c.106.008.213.012.321.013a5.848,5.848,0,0,0,4.308-2.209,6.829,6.829,0,0,0,1.6-4.941A.25.25,0,0,0,155.453,0Z",
    transform: "translate(-109.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(155 407)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.029em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(155 427)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    letterSpacing: "0.029em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.d694a2919743ac39154b7828d4c275c3.svg";
export { ForwardRef as ReactComponent };